import { Component, OnInit, Input } from '@angular/core';
import {paymentMethod} from "../../../../shared/models/group-portal-data.models";

@Component({
	selector: 'payment-methods-dashboard',
	templateUrl: './payment-methods-dashboard.component.html'
})

export class PaymentMethodsDashboardComponent implements OnInit {
	@Input() paymentMethods: paymentMethod[] = [];
	@Input() paymentMethodDoneProcessing: boolean;
	ngOnInit() { }
}